import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { buildApiUrl, ensureArray, getApiHeaders } from "../config";

const SignalsPreviewSection = () => {
  const navigate = useNavigate();
  const [signals, setSignals] = useState([]);

  useEffect(() => {
    let cancelled = false;

    fetch(buildApiUrl("/api/bot/ui/mtf/latestSignals", { mode: "PUBLIC" }), {
      headers: getApiHeaders(),
      cache: "no-store",
    })
      .then((response) => {
        if (!response.ok) throw new Error(`Signal preview returned ${response.status}`);
        return response.json();
      })
      .then((rows) => {
        if (!cancelled) setSignals(ensureArray(rows).slice(0, 3));
      })
      .catch(() => {
        if (!cancelled) setSignals([]);
      });

    return () => {
      cancelled = true;
    };
  }, []);

  return (
    <section className="section dark">
      <h2 className="section-title">
        🔥 Live Multi-Timeframe Signals (Preview)
      </h2>

      <div className="glass-card">
        <ul className="signal-list">
          {signals.length > 0 ? signals.map((signal, index) => (
            <li key={`${signal.symbol}-${signal.timeFrame}-${index}`}>
              {signal.symbol} · {signal.timeFrame}m · {signal.side || "Live signal"}
            </li>
          )) : (
            <li>No preview signals are currently available.</li>
          )}
        </ul>

        <button
          className="primary-btn"
          style={{ marginTop: 20 }}
          onClick={() => navigate("/mtf-signals-v2")}
        >
          MTF Signal Dashboard V2 →
        </button>
        <div>
          <br />
          <button
            className="glossary-link"
            onClick={() => { window.location.href = "/glossary"; }}
          >
            📘 Trading Terms (Glossary)
          </button>
        </div>
      </div>
    </section>
  );
};

export default SignalsPreviewSection;
